export default "__VITE_ASSET__BJncRcLG__"